import directives from './module';
import {HttpSvcFactory} from '../services/HttpSvc';

class uploadProject implements ng.IComponentController {
    uploadingProject: boolean;

    constructor(private $scope: ng.IScope,
                private $element: ng.IAugmentedJQuery,
                private $http: ng.IHttpService,
                private $state: ng.ui.IStateService,
                private HttpSvc: HttpSvcFactory) {
    }

    $onInit() {
        this.$element[0].onchange = e => this.$scope.$apply(() => {
            const fd = this.getFormData();
            this.upload(fd);
        });
    }

    private getFileTag() {
        return <HTMLInputElement>(this.$element[0].querySelector('input[type="file"]'));
    }

    private getFormData() {
        const file = this.getFileTag().files[0];
        const fd   = new FormData();
        fd.append('file', file);

        return fd;
    }

    private getProjectUrl() {
        return this.HttpSvc('project/list?product=wave')
            .get()
            .then(r => r.data)
            .then((data: anm.SearchResult<anm.Project>) => {
                const projectId = data.results[0].id;
                return `https://upload.animatron${options.isProduction ? '' : '-test'}.com/assets/${projectId}/${options.user.hash}`;
            })
    }

    private upload(fd: FormData) {
        this.getProjectUrl()
            .then((url: string) => this.$http.post(url, fd, {
                transformRequest: angular.identity,
                transformResponse: angular.identity,
                headers: _.extend({'Content-Type': undefined}, options.headers)
            }))
            .then(r => r.data)
            .then((rawResponse: string) => {
                const response  = JSON.parse(rawResponse.replace('=', ':'));
                const projectId = response.projectId;
                this.$state.go('project', {projectId});
            })
            .catch(err => {
                console.error(err);
                _.notification.showError('Couldn\'t upload project');
            })
            .finally(() => {
                this.uploadingProject   = false;
                this.getFileTag().value = null;
            });
    }
}

directives.component('uploadProject', {
    controller: uploadProject,
    template: `<button-spinner
                 style="white-space: nowrap;"
                 loading="$ctrl.uploadingProject">
                   {{::$root.t('upload.project')}}
                   <input type="file" accept=".anm"/>
              </button-spinner>`
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/uploadProject.ts